import React from "react";

class TopLevelErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }
  
    componentDidCatch(error, info) {
      // Example "componentStack":
      //   in ComponentThatThrows (created by App)
      //   in ErrorBoundary (created by App)
      //   in div (created by App)
      //   in App
      console.log(error)
      console.log(info)
    //   localStorage.clear()
    }
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        localStorage.clear()
        return this.props.children;
      }
  
      return this.props.children;
    }
  }

export default TopLevelErrorBoundary;